export const CSS_CLASSES = {
  MAIN_WRAPPER: 'main-wrapper',
} as const;
